import { Alert, AlertDescription } from '@/components/ui/alert';
import { EdlinkOrgChartDryRunResult, EdlinkOrgChartImportSummary } from '@airreading/common/data';
import { ImportSummary } from './import-summary';

export type EdlinkSyncResult =
  | {
      type: 'success';
      summary: EdlinkOrgChartImportSummary | EdlinkOrgChartDryRunResult;
      entityName: string;
      entityId: string;
    }
  | { type: 'error'; message: string };

export function EdlinkSyncResultView({ result }: { result: EdlinkSyncResult | null }) {
  if (!result) {
    return null;
  }

  if (result.type === 'error') {
    return (
      <Alert variant="destructive">
        <AlertDescription>{result.message}</AlertDescription>
      </Alert>
    );
  }

  return <ImportSummary summary={result.summary} entityName={result.entityName} entityId={result.entityId} />;
}
